import * as React from 'react';
import { ExchangeProvider } from '@entities/exchange';
import { Router } from '@shared/lib/router';
import { exchangeRouter } from './router';
const Exchange = ({ updateOrder }) => {
    return (React.createElement(ExchangeProvider, { updateOrder: updateOrder },
        React.createElement(Router, { router: exchangeRouter })));
};
export default Exchange;
